import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import './index.css'
import { Layout } from './components/Layout'
import { Landing } from './pages/Landing'
import { Cases } from './pages/Cases'
import { CaseViewer } from './pages/CaseViewer'
import { DoctorCases } from './pages/DoctorCases'
import { Docs } from './pages/Docs'
import { Tech } from './pages/Tech'
import { Thanks } from './pages/Thanks'
import { Upload } from './pages/Upload'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/cases/:caseId" element={<CaseViewer />} />
          <Route path="/doktor" element={<DoctorCases />} />
          <Route path="/hakkinda" element={<Docs />} />
          <Route path="/tesekkur" element={<Thanks />} />
          <Route path="/teknik-detaylar" element={<Tech />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </StrictMode>,
)
